<template>
  <div class="static-page">

    <section class="static-page__hero">
      <div class="static-page__hero-backdrop">
        <img class="static-page__hero-image" :src="`assets/images/liveeps/statics/${is_vivamod() ? 'iStock-1279796005.jpg' : 'about-hero.jpg'}`" alt="viaggia con noi hero" />
      </div>
    </section>

    <!-- cos'è vadobay -->
    <section class="section">
      <div class="static-page__isvadobay" id="vadobay">
        <b-container v-if="is_vivamod()">
          <div>
            <p class="h3 text-center">
              <span class="bold">Vivamod</span> è la piattaforma ideale per chi vuole integrare al proprio ecosistema digitale un vero e proprio sito di viaggi, accessibile a utenti che godono di convenzioni esclusive (ad esempio convenzioni aziendali), o che hanno a disposizione branded currency da sfruttare (ad esempio punti fedeltà).
            </p>
            <p class="h3 text-center bold">
              Vivamod mette a disposizione oltre 200,000 strutture del catalogo Expedia: i migliori hotel, b&b e appartamenti in tutto il mondo.
            </p>
          </div>
        </b-container>
        <b-container v-else>
          <h2 class="vb-heading h3 mb-5" v-html="get_config('site.brand', '')" />
          <div v-if="is_vivamod()">
            {{ get_config('site.brand', '') }} è la piattaforma per prenotare oltre 200,000 di strutture del catalogo Expedia utilizzando i tuoi crediti welfare. Scegli tra i migliori hotel, b&b e appartamenti in tutto il mondo, senza dover stampare voucher, utilizzare la carta di credito o affrontare procedure di acquisto complesse.
          </div>

          <div v-else-if="is_hotels()">
            {{ get_config('site.brand', '') }} è il sito che ti permette di acquistare centinaia di migliaia di hotel del catalogo {{ get_config('site.brand', '') }}  utilizzando i tuoi crediti welfare. Questo significa che puoi accedere ai migliori hotel, b&b, appartamenti in tutto il mondo senza dover scaricare voucher, usare la tua carta di credito, o impegnarti in complicati processi di acquisto.
          </div>
        
          <div v-else><!-- vadobay -->
            <p class="mb-2">
              {{ get_config('site.brand', '') }} è un sito di online travel booking che ti permette di acquistare servizi di viaggio con i crediti welfare messi a disposizione dalla tua azienda: niente voucher, niente coupon e niente carte di credito ma una prenotazione diretta e immediata usando il tuo credito welfare.
            </p>
            <p class="mb-2">
              Tutto questo avviene grazie alla nostra tecnologia e grazie ad una partnership vincente con Expedia Partner Solutions, uno dei leader globali del travel online.
            </p>
          </div>
        </b-container>
      </div>
    </section>


    <section class="section mb-0">
      <value-proposition v-if="is_vivamod()"
        :vp="[
          {
            vp_image: 'assets/images/liveeps/statics/iStock-2206674132.jpg',
            vp_content: [
              {
                //vp_icon: 'symbol_vv',
                vp_title: 'Tanti vantaggi per i tuoi migliori clienti',
                vp_text: `<p>Grazie a Vivamod hai:</p>
                  <ul style='list-style:auto' class='mt-4'>
                    <li><p><span class='bold text-secondary'>Accesso diretto e protetto</span> dal tuo ecosistema digitale, senza bisogno di effettuare più login o ricordare password aggiuntive</p></li>
                    <li><p>Un'<span class='bold text-secondary'>esperienza di ricerca e prenotazione chiara</span>, veloce e senza intoppi</p></li>
                    <li><p>Un <span class='bold text-secondary'>team di esperti</span> sempre pronti a supportarti via email, WhatsApp o telefono, con risposte rapide in pochi minuti</p></li>
                    <li><p>Un <span class='bold text-secondary'>consulente</span> che contatta la struttura prima del tuo arrivo, per garantirti un soggiorno senza imprevisti</p></li>
                  </ul>`,
              },
            ]
          },
        ]"/>
      <value-proposition v-else-if="is_hotels()"
        :vp="[
          {
            vp_image: 'assets/images/liveeps/statics/about-vadobay.jpg',
            vp_content: [
              {
                //vp_icon: 'symbol_vv',
                vp_title: 'Più valore al tuo welfare!',
                vp_text: '<p>Con Hotels by Vivamod hai a disposizione:</p><ul style=\'list-style:auto\' class=mt-4>\
                <li><p><span class=\'bold text-secondary\'>Accesso sicuro</span> tramite il tuo portale welfare senza doppio login e doppie credenziali</p></li>\
                <li><p><span class=\'bold text-secondary\'>Percorso di ricerca e acquisto</span> fluido e semplice</p></li>\
                <li><p><span class=\'bold text-secondary\'>Travel specialist</span> che rispondono in pochi minuti a email, WhatsApp, telefono</p></li>\
                <li><p>Un <span class=\'bold text-secondary\'>assistente “umano”</span> che chiama l’hotel prima del tuo arrivo, per evitare brutte sorprese</p></li>\
                <ul>\
                ',
              },
            ]
          },
        ]"/>
      <value-proposition v-else
        :vp="[
          {
            vp_image: 'assets/images/liveeps/statics/about-vadobay.jpg',
            vp_content: [
              {
                //vp_icon: 'symbol_vv',
                vp_title: 'Un servizio a valore aggiunto per i titolari di welfare aziendale',
                vp_text: '<ul style=\'list-style:auto\' class=mt-4>\
                <li><p><span class=\'bold text-secondary\'>assistenza diretta e multicanale</span> al telefono, in webchat e su WhatsApp curata dal nostro team di customer care interno</p></li>\
                <li><p>un <span class=\'bold text-secondary\'>team di assistenza esperto</span> nel gestire le specifiche esigenze dell\'utenza di <span class=\'bold text-secondary\'>welfare aziendale</span></p></li>\
                <li><p>un servizio dedicato che <span class=\'bold text-secondary\'>verifica ogni prenotazione</span> prima del tuo arrivo a destinazione</p></li>\
                <li><p>un algoritmo che seleziona le migliori strutture in base a <span class=\'bold text-secondary\'>qualità esperienza e professionalità</span></p></li>\
                <ul>\
                ',
              },
            ]
          },
        ]"/>        
    </section>
    
    <!-- prenota un viaggio -->
    <section class="section mt-0" id="prenota-un-viaggio">
      <value-proposition v-if="is_vivamod()"
        :invert="true"
        :vp="[
          {
            vp_image: 'assets/images/liveeps/statics/iStock-1252716407.jpg',
            vp_content: [
              {
                //vp_icon: 'symbol_vv',
                vp_title: 'Come funziona',
                vp_text: `<ul style='list-style:auto' class='mt-4'>
                  <li><p>Contatta il nostro <span class='bold text-secondary'>team commerciale</span> per una demo personalizzata!</p></li>
                  <li><p>Il <span class='bold text-secondary'>team sviluppo</span> progetterà per te un’integrazione ad hoc per permettere ai clienti del tuo programma fedeltà, oppure ai tuoi associati/dipendenti/ clienti che beneficiano di convenzioni, di accedere in maniera protetta e sicura tramite Single-sign-on.</p></li>
                  <li><p>Il <span class='bold text-secondary'>team creativo</span> personalizzerà il sito di prenotazione con il tuo logo, i tuoi colori, e altre specifiche.</p></li>
                  <li><p>I tuoi clienti/dipendenti/associati potranno prenotare utilizzando punti fedeltà o godendo di prezzi esclusivi, senza necessità di doppi login, procedure complicate o download voucher.</p></li>
                </ul>`,
              },
            ]
          },
        ]"/>

      <value-proposition v-else-if="is_hotels()"
        :invert="true"
        :vp="[
          {
            vp_image: 'assets/images/liveeps/statics/about-prenota.jpg',
            vp_content: [
              {
                //vp_icon: 'symbol_vv',
                vp_title: 'Come funziona',
                vp_text: '<ul style=\'list-style:auto\' class=mt-4>\
                  <li><p><span class=\'bold text-secondary\'>Accedi</span> al tuo portale welfare</p></li>\
                  <li><p><span class=\'bold text-secondary\'>Cerca '+get_config('site.brand', '')+'</span> tra i fornitori di servizi welfare</p></li>\
                  <li><p>'+get_config('site.brand', '')+' <span class=\'bold text-secondary\'>non necessita</span> di un ulteriore accesso: il tuo credito welfare viene riconosciuto in modo sicuro</p></li>\
                  <li><p><span class=\'bold text-secondary\'>Prenota la struttura</span> che fa per te: non dovrai usare la tua carta di credito né scaricare voucher. Ti verranno scalati i crediti welfare e la prenotazione sarà confermata senza ulteriori azioni di parte tua</p></li>\
                  <li><p><span class=\'bold text-secondary\'>Controlla la mail</span> per eventuali comunicazioni e affidati al servizio clienti per qualunque dubbio o informazione</p></li>\
                </ul>\
                ',
              },
            ]
          },
        ]"/>

      <value-proposition v-else
        :invert="true"
        :vp="[
          {
            vp_image: 'assets/images/liveeps/statics/about-prenota.jpg',
            vp_content: [
              {
                //vp_icon: 'symbol_vv',
                vp_title: 'Come funziona',
                vp_text: '<ul style=\'list-style:auto\' class=mt-4>\
                  <li><p><span class=\'bold text-secondary\'>Accedi</span> al tuo portale welfare</p></li>\
                  <li><p><span class=\'bold text-secondary\'>Cerca '+get_config('site.brand', '')+'</span> tra i fornitori di servizi welfare</p></li>\
                  <li><p>Cerca, <span class=\'bold text-secondary\'>prenota online</span> e ricevi la conferma di prenotazione</p></li>\
                  <li><p>Prima della partenza, ricevi per email il <span class=\'bold text-secondary\'>voucher per il checkin</span></p></li>\
                  <li><p><span class=\'bold text-secondary\'>Buon viaggio</span> e buone vacanze!</p></li>\
                </ul>\
                ',
              },
            ]
          },
        ]"/>


      <!--<div class="static-page__prenota" id="prenota-un-viaggio">
        <b-container>
          <div>
            <h2 class="vb-heading h3 mb-3" v-html="'Come funziona'" />
            <ul>
              <li>Accedi al tuo portale welfare</li>
              <li>Cerca {{get_config('site.brand', '')}} |  {{ get_config().site.payoff }} tra i fornitori di servizi welfare</li>
              <li>Cerca, prenota online e ricevi la conferma di prenotazione</li>
              <li>Prima della partenza, ricevi per email il voucher per il checkin</li>
              <li>Buon viaggio e buone vacanze!</li>
            </ul>
          </div>
        </b-container>
      </div>-->
    </section>

    <!-- contattaci -->
    <section class="section">
      <div class="static-page__form" id="contattaci">
        <b-container class="p-0">
          <form-contatti
              :formTitle="title_request_form"
              :formSubTitle="subtitle_request_form"
              :label="'form-contatti-prenota-un-viaggio'"
              :recipient="site.emailSupport"
          />
        </b-container>
      </div>
    </section>


    <section class="section">
      <div class="static-page text-center">
        <b-container>
          <p class="pt-4 pb-4">
            {{get_config('site.brand', '')}} è un marchio Salabam Solutions. Se desideri conoscere l'intera gamma di servizi travel tech che possiamo offrire, vieni a trovarci sul sito di Salabam Solutions!
          </p>
        </b-container>
      </div>
    </section>


  </div>
</template>


<script>
import Vue from "vue";
import FormContatti from '@components/blocks/form-contatti.vue'
import ValueProposition from '@library/blocks/value-proposition.vue'

export default {
  name: 'about',
  components:{
    'form-contatti': FormContatti,
    'value-proposition': ValueProposition,
  },
  props: {
  },
  created() {
  },
  data () {
    return {
      config: Vue.prototype.$config,
      site: Vue.prototype.$config.site,
      title_request_form: 'Hai bisogno di <span class=\'text-secondary\'>maggiori informazioni?</span> Contattaci!',
      subtitle_request_form: 'Compila il seguente form oppure scrivi una mail a <a href=\'mailto:' + Vue.prototype.$config.site.emailSupport + '\'>' + Vue.prototype.$config.site.emailSupport + '</a>. Se cerchi un contatto B2B, <b><a href="https://salabamsolutions.com/contatti" target="_blank">vai qui!</a></b>',
    }
  },
  computed: {
  },
}
</script>


<style lang="scss">

  .static-page {

    &__hero {
      height: 280px;
      @include media-breakpoint-up(md) {
        height: 320px;
      }
      @include media-breakpoint-up(lg) {
        height: 360px;
      }
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
    }

    &__isvadobay {
      padding: 60px 0;
    }

    &__prenota {
      .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      ul {
        margin-top: 2rem;
      }
      li {
        font-size: 1.1rem;
        margin-bottom: 0.25rem;
      }
    }

    &__brands {
      padding: 60px 0;
      svg {
        width: 100%;
        max-width: 220px;
        height: auto;
        margin:auto;
        margin-top: 2rem;
        margin-bottom: 1rem;
      }
      p {
        margin: 1rem auto;
        max-width: 300px;
      }
    }

    &__form {
      padding: 0 0 60px 0;
      form {
        padding: 0 !important;
      }
    }
  }

</style>